import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  exportType?: DBExportType;
};

type Response = {
  count: number;
};

export const getRecurringExportsCount = async (
  scope: RequestScope,
  { exportType }: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>('/recurring_export/count', {
      ...options,
      params: {
        ...(exportType ? { query: { export_type: exportType } } : {}),
      },
    });

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
